import styled from 'styled-components';

export const StaffSiteRoleRowSelectWrapper = styled.div`
  display: flex;
  gap: var(--s3);
`;
